import { default as SuccessIcon } from '../components/Tick2';

export default SuccessIcon;
